import { Component, OnInit } from '@angular/core';
import { Detail } from 'app/interfaces/detail.model';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Project } from 'app/interfaces/project.model';
import * as _ from 'lodash';
import { ProjectService } from 'app/modules/project/services/project.service';

@Component({
  selector: 'app-detail-detail',
  templateUrl: './detail-detail.component.html',
  styleUrls: ['./detail-detail.component.scss']
})
export class DetailDetailComponent implements OnInit {
  detail: any;
  projects: Array<Project>;
  activeImage: any;
  images = [];
  tab1Active = false;
  tab2Active = false;
  tab3Active = false;
  groupedImages: Array<any>;
  group1Active = false;
  backUrl = { url: '/details', text: 'Back to details' };

  constructor(private router: Router, private route: ActivatedRoute, private projectService: ProjectService) { }

  ngOnInit() {
    this.route.data.subscribe((a) => {
      if (a) {
        this.detail = a.detail;

        this.projectService.getByDetail(this.detail).subscribe(p => this.projects = p);

        this.detail.Files.forEach(element => {
          element.orientation = 0;
          element.active = 0;
          this.images.push(element);
        });

        const previousUrl = localStorage.getItem('previousUrl');
        if (previousUrl.startsWith('/page') || previousUrl.startsWith('/details/page')) {
          this.backUrl.url = previousUrl;
          if (previousUrl.startsWith('/page')) {
            this.backUrl.text = 'Back to home';
          }
        }

        this.groupedImages = _.chain(this.images).groupBy('Category').map((b, c) => { return { category: c, items: b }; }).value();
      }
    });
  }

  objArrayToString(objects: Array<any>) {
    if (!objects || objects.length === 0) {
      return '';
    }
    return objects.map(a => a.Name).join(', ');
  }

  imageLoaded(image, event) {

    const w = event.path[0].width;
    const h = event.path[0].height;

    if (w > h) {
      image.orientation = 'LANDSCAPE';
    }
    if (w <= h) {
      image.orientation = 'PORTRAIT';
    }
  }
}
